import { Component, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { NgClass } from '@angular/common';

import { ResponseService } from '../../../../../../services/response.service';
import { RepeatableRandomGeneratorService } from '../../../../../../services/repeatable-random-generator.service';

@Component({
    selector: 'inline-choice-interaction',
    template: require('./inline-choice-interaction.html')
})
export class InlineChoiceInteractionComponent implements OnInit, OnDestroy {
    @Input() interaction: PgRendererDto.InteractionDefinition;

    inlineChoiceInteraction: PgRendererDto.InlineChoiceInteraction;
    isToggleOn: boolean;
    answerText: string;
    parentElement: HTMLElement;

    constructor(
        private responseService: ResponseService,
        private elementRef: ElementRef,
        private repeatableRandomGeneratorService: RepeatableRandomGeneratorService
        ) {
            this.isToggleOn = false;
            this.answerText = "";
    }

    ngOnInit() {
        this.inlineChoiceInteraction = Object.assign({}, this.interaction.InlineChoiceInteraction);

        this.repopulateSelections();
        window.document.addEventListener("click", this.handleOutsideClick);
        if (this.inlineChoiceInteraction.Shuffle == true) {
            this.inlineChoiceInteraction.InlineChoices = this.repeatableRandomGeneratorService.randomizeArray(this.inlineChoiceInteraction.InlineChoices);
        }
        for (let index = 0; index < this.inlineChoiceInteraction.InlineChoices.length; index++) {
            this.inlineChoiceInteraction.InlineChoices[index].ChoiceDisplayOrder = index + 1;
        }
    }

    ngOnDestroy() {
        window.document.removeEventListener("click", this.handleOutsideClick);
    }

    inlineOnToggle(menuElement) {
        this.isToggleOn = !this.isToggleOn;
        const elem = (this.elementRef.nativeElement as HTMLElement);
        if (elem.offsetTop > 450) {
            let parentElement = elem.parentElement;
            while (parentElement) {
                parentElement = parentElement.parentElement;
                if (parentElement.classList.contains("pane-content")) {
                    break;
                }
            }

            if (parentElement) {
                $(parentElement).css("scroll-behavior", "smooth");
                parentElement.scrollTop = elem.offsetTop - 10;
            }
        }
        if (this.isToggleOn) {
            this.getMenuOffsets(menuElement.parentElement)
        }
    }

    private selectChoice(index: string, text: string) {
        this.answerText = text;
        this.isToggleOn = false;
    }

    setResponse(identifier: string, text: string) {
        const choice = this.interaction.InlineChoiceInteraction.InlineChoices.find(x => x.Identifier == identifier);
        let choiceDisplayOrder: number = null;
        if(choice) {
            choiceDisplayOrder = choice.ChoiceDisplayOrder;
        }
        this.responseService.setResponse(this.interaction, null, identifier, null, false, choiceDisplayOrder);
        this.selectChoice(identifier, text);
    }

    private repopulateSelections(): void {
        const response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            const item = response.Items[0];
            const choice = this.interaction.InlineChoiceInteraction.InlineChoices.find(x => x.Identifier == item.Value);
            if (choice) {
                this.selectChoice(item.Value, choice.Html);
            }
        }
    }

    handleOutsideClick = (event) => {
        let clickedComponent = event.target;
        while (clickedComponent) {
            if (clickedComponent === this.elementRef.nativeElement) {
                return;
            }
            clickedComponent = clickedComponent.parentNode;
        }
        this.isToggleOn = false;
    }

    getMenuOffsets(divElement:Element) {
        let paneDomRect;
        if (!document.getElementsByClassName("rightpane")[0]) {
            paneDomRect = document.getElementsByClassName("singlePane")[0].getBoundingClientRect();
        } else {
            paneDomRect = document.getElementsByClassName("rightpane")[0].getBoundingClientRect();
        }
        let leftDivider = paneDomRect.left + (5.70*paneDomRect.width/16);
        let rightDivider = paneDomRect.left + (10.30*paneDomRect.width/16);
        let subElems = Array.from(divElement.children);
        let toggleDomRect = subElems[0].getBoundingClientRect();
        let toggleMid = toggleDomRect.left + (toggleDomRect.width/2);
        let menuDomRect = subElems[1].getBoundingClientRect();

        if (toggleMid <= leftDivider) {
            subElems[1].setAttribute("style", "left:0;");
        }
        else if ((leftDivider < toggleMid) && (toggleMid < rightDivider)) {
            subElems[1].setAttribute("style", "left:-" + ((menuDomRect.right - toggleDomRect.right)/2).toString() + "px;");
        }
        else if(toggleMid > rightDivider){
            subElems[1].setAttribute("style", "left:-" + ((toggleMid - rightDivider)/2).toString() + "px;");
        }
        else {
            subElems[1].setAttribute("style", "left:-" + (menuDomRect.right - toggleDomRect.right) + "px;");
        }
    }   
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/inline-choice-interaction/inline-choice-interaction.component.ts